// @flow
import { dashboardUrl } from 'frontend_core/dist/helpers/url'
import { wwwUrl } from 'frontend_core/dist/helpers/url'

export default {
  login: (doneUrl: string = '') => `/login${doneUrl ? `?done=${doneUrl}` : ''}`,
  signUp: () => '/sign_up',
  signOut: () => '/sign_out',
  signUpSent: () => '/sign_up/sent',
  signUpReconfirmation: () => '/sign_up/reconfirmation',
  notificationSetting: (service: string = ':service') =>
    `/settings/notifications/${service}`,
  passwordReset: () => '/password_reset/new',
  passwordResetEdit: (token: string) => `/password_reset/edit`,
  hostEntry: () => '/pages/host_entry',
  dashboard: (owner, path) => dashboardUrl(owner, path),
  wwwAboutHowToUse: () => wwwUrl('/about/how_to_use'),
  hostSignUp: () => '/host_sign_up',
}
